export default __webpack_public_path__ + "static/media/table-down.8a4ed405.svg";